import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { DataTable } from "../../../common/DataTable";
import { BROKERS } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";
import { ArchiveButton, CheckboxButton, EditButton } from "../../../common";
import BrokerForm from "./BrokerForm";
import { ButtonToolbar } from "react-bootstrap";
import userHasAccess from "../../../../utils/userHasAccess";
import { DIRECTOR } from "../../../../utils/Roles";

class BrokersDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this.props.clearBrokers();
  }

  getTranslation = (token) => (
    <FormattedMessage id={`admin.brokers.${token}`} />
  );

  displayCell = (field) => (broker) => {
    const classes = broker.isArchived ? "archived" : "";
    return <span className={classes}>{broker[field]}</span>;
  };

  getColumns = () =>
    [
      {
        columnName: "broker",
        display: this.displayCell("fullName"),
        widthPct: 20,
      },
      {
        columnName: "adminContact",
        display: this.displayCell("adminContactFullName"),
        widthPct: 20,
      },
      {
        columnName: "adminPhoneNumber",
        display: this.displayCell("adminPhoneNumber"),
        widthPct: 20,
      },
      {
        columnName: "adminEmailAddress",
        display: this.displayCell("adminEmailAddress"),
        widthPct: 20,
      },
      {
        columnName: "actions",
        display: this.getRowActions,
        widthPct: 20,
      },
    ].map((col, key) => ({
      ...col,
      key,
      name: this.getTranslation(col.columnName),
    }));

  createBrokerAndRefreshList = (...args) => {
    this.props.createBroker(...args).then(this.props.refreshList);
  };

  displayArchived = () => !this.props.filters.includes(BROKERS.archiveFilter);

  toggleArchivedRowDisplay = () => {
    const filters = !this.displayArchived()
      ? this.props.filters.filter((filter) => filter !== BROKERS.archiveFilter)
      : [...this.props.filters, BROKERS.archiveFilter];
    this.props.getBrokerList(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  };
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  getTableActions = () => {
    const label = this.getTranslation("add");
    const title = this.getTranslation("addBroker");
    return (
      <div>
        <CheckboxButton
          className="include-archived"
          id="archived"
          label={this.getTranslation("includeArchived")}
          checked={this.displayArchived()}
          onClick={this.toggleArchivedRowDisplay}
        />
        <EditButton
          modalClassName="extra-large-modal"
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          title={title}
          label={label}
          add={true}
          form={BrokerForm}
          props={{ translateFn: this.getTranslation }}
          data={{ type: "BROKER" }}
          editFunction={this.createBrokerAndRefreshList}
        />
      </div>
    );
  };

  updateBrokerAndRefresh = (...args) => {
    this.props.updateBroker(...args).then(this.props.refreshList);
  };

  getRowActions = (broker) => {
    const label = this.getTranslation("modify");
    const title = this.getTranslation("modifyBroker");
    return (
      <ButtonToolbar key={1}>
        <EditButton
          modalClassName="extra-large-modal"
          form={BrokerForm}
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          title={title}
          label={label}
          data={broker}
          getData={this.getBroker}
          props={{ translateFn: this.getTranslation }}
          editFunction={this.updateBrokerAndRefresh}
        />
        {!broker.isArchived && (
        <ArchiveButton
          showDefaultDanger={true}
          isArchived={broker.isArchived}
          archivedName={broker.fullName}
          disabled={!userHasAccess(DIRECTOR)}
          archiveFunction={this.makeArchivingToggleFunction(broker)}
          label={
            broker.isArchived ? (
              <FormattedMessage id="common.unarchive" />
            ) : (
              <FormattedMessage id="common.archive" />
            )
          }
        />    
      )}
      </ButtonToolbar>
    );
  };

  makeArchivingToggleFunction = (broker) => () => {
    this.props
      .updateBroker({
        brokerId: broker.brokerId,
        isArchived: !broker.isArchived,
      })
      .then(() => this.props.refreshList());
  };

  render() {
    const { getBrokerList } = this.props;
    return (
      <DataTable
        ref="dataTable"
        getData={getBrokerList}
        cols={this.getColumns()}
        q={this.props.q}
        filters={this.props.filters}
        offset={this.props.offset}
        data={this.props.brokers}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.getTableActions()}
      />
    );
  }
}

BrokersDataTable.propTypes = {
  active: PropTypes.object,
  authLanguageCode: PropTypes.string,
  filters: PropTypes.array,
  insurersActions: PropTypes.object,
  brokers: PropTypes.array,
  q: PropTypes.string,
  languages: PropTypes.array.isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  userLanguage: PropTypes.string,
  insurers: PropTypes.array,
  getBrokerList: PropTypes.func,
  createBroker: PropTypes.func,
  getBroker: PropTypes.func,
  clearBrokers: PropTypes.func,
  updateBroker: PropTypes.func,
  refreshList: PropTypes.func,
};

const defaultSorters = ["createdAt:desc"];
const defaultFilters = [BROKERS.archiveFilter];
const defaultLimit = 10;

function mapStateToProps(state) {
  const brokers = state.data.brokers || {};
  const pagination = brokers.pagination || {};
  return {
    active: brokers.active || {},
    authLanguageCode: state.auth.user.languageCode,
    limit: pagination.limit || defaultLimit,
    offset: pagination.offset || 0,
    sortBy: brokers.sortBy || defaultSorters,
    q: brokers.q,
    filters: brokers.filters || defaultFilters,
    total: pagination.totalCount || 0,
    brokers: brokers.items,
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  refreshList: () =>
    dispatch(
      dataActions.getDataList(
        BROKERS,
        props.offset,
        props.limit,
        props.q,
        props.sortBy || defaultSorters,
        props.filters || defaultFilters
      )
    ),
  getBrokerList: (...args) =>
    dispatch(dataActions.getDataList(BROKERS, ...args)),
  getBroker: (...args) => dispatch(dataActions.getDataItem(BROKERS, ...args)),
  clearBrokers: () => dispatch(dataActions.clearDataList(BROKERS)),
  createBroker: (values) =>
    dispatch(dataActions.createDataItem(BROKERS, values)),
  updateBroker: (broker) =>
    dispatch(dataActions.updateDataItem(BROKERS, broker)),
});
export default connect(mapStateToProps, mapDispatchToProps)(BrokersDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/brokers/BrokersDataTable.js